export default __webpack_public_path__ + "static/media/tutorial3.c9cce6ff.png";